'use client'

import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'

const ScrollToTopButton: React.FC = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const el = document.body

    const toggleVisibility = () => {
      setVisible(el.scrollTop > 500)
    }

    el.addEventListener('scroll', toggleVisibility)
    return () => el.removeEventListener('scroll', toggleVisibility)
  }, [])

  const scrollToTop = () => {
    window.document.body.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button
      className={`${styles.scrollToTop} ${visible ? styles.visible : ''}`}
      onClick={scrollToTop}
    >
      <svg
        enableBackground="new 0 0 32 32"
        height="32px"
        id="Layer_1"
        version="1.1"
        viewBox="0 0 32 32"
        width="32px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.221,7.206l9.585,9.585c0.879,0.879,0.879,2.317,0,3.195l-0.8,0.801c-0.877,0.878-2.316,0.878-3.194,0  l-7.315-7.315l-7.315,7.315c-0.878,0.878-2.317,0.878-3.194,0l-0.8-0.801c-0.879-0.878-0.879-2.316,0-3.195l9.587-9.585  c0.471-0.472,1.103-0.682,1.723-0.647C17.115,6.524,17.748,6.734,18.221,7.206z"
          fill="currentColor"
        />
      </svg>
    </button>
  )
}

export default ScrollToTopButton
